import React, { useEffect, useState } from 'react';
import { doc, getDoc, collection, getDocs, updateDoc, arrayRemove } from 'firebase/firestore';
import { auth, db } from '../firebase/config';
import Table from 'react-bootstrap/Table';
import Alert from 'react-bootstrap/Alert';
import '../App.css'
import { useNavigate } from 'react-router-dom';

function StudentClassesTable() {
    const [enrolledCourses, setEnrolledCourses] = useState([]);
    const [successMessage, setSuccessMessage] = useState('');
    async function deleteAppointment(id) {
        try {
            const user = auth.currentUser;
            if (user) {
                const userDocRef = doc(db, "users", user.uid);
                
                await updateDoc(userDocRef, {
                    enrolledCourses: arrayRemove(id)
                });
                fetchEnrolledCourses()

                setSuccessMessage("Appointment deleted successfully!")

                setTimeout(() => setSuccessMessage(""), 2000); 


            }
            
        }

        catch (err) {
            console.error(err)
        }

    }

    const fetchEnrolledCourses = async () => {
        const user = auth.currentUser;
        if (user) {
            // Get the user's enrolled courses from the users collection
            const userDocRef = doc(db, "users", user.uid);
            const userSnapshot = await getDoc(userDocRef);
            if (userSnapshot.exists()) {
                const userCourses = userSnapshot.data().enrolledCourses || [];
                // Fetch the full details of each enrolled course
                const classesCollection = collection(db, "classes");
                const coursesSnapshot = await getDocs(classesCollection);
                const coursesList = coursesSnapshot.docs
                    .filter(course => userCourses.includes(course.id))
                    .map(course => ({ id: course.id, ...course.data() }));

                setEnrolledCourses(coursesList);
              

            }
        }
    };


    useEffect(() => {
      
        fetchEnrolledCourses();
    }, []);
    

    return (
        <>

           { successMessage &&  <Alert variant="success">
                {successMessage}
            </Alert>}
      
      <Table className = "student-course-table" striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>Department</th>
                        <th>Course Number</th>
                        <th>Subject</th>
                        <th>Instructor</th>
                        {enrolledCourses.length > 0 && <th>Action</th>}
                    </tr>
                </thead>
                <tbody>
                    {enrolledCourses.map(course => (
                        <tr key={course.id}>
                            <td>{course.name}</td>
                            <td>{course.abbreviatedName}</td>
                            <td>{course.subject}</td>
                            <td>{course.instructorName}</td>
                            {<td className = "deleteButtonColumn">
                                <button className="deleteButton btn btn-danger"  onClick={() => deleteAppointment(course.id)} type="button">delete</button>
                            </td>
}
                        </tr>

                    ))}
                </tbody>
            </Table>
            <div className="container">
  <div className="student-course-row">
    {enrolledCourses.map(course => (
      <div className="col-md-4 mb-4" key={course.id}>
        <div className="card h-100 shadow-sm">
          <div className="card-body">
            <p className="card-title"> <strong>Course Name:</strong> {course.name}</p>
            <strong>Course Num:</strong>{course.abbreviatedName}
            <p className="card-text">
              <strong>Section:</strong> {course.section}<br/>
              <strong>Instructor:</strong> {course.instructorName}<br/>
              <strong>Email:</strong>{course.email}
            </p>
          </div>
          {enrolledCourses.length > 0 && (
            <div className="card-footer text-end">
              <button 
                className="btn btn-danger deleteButton" 
                onClick={() => deleteAppointment(course.id)} 
                type="button"
              >
                delete
              </button>
            </div>
          )}
        </div>
      </div>
    ))}
  </div>
</div>


           
        </>

    );
}

export default StudentClassesTable;
